import { ThemeEvents } from '@theme/events';

class ProductCardSwatches extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setVariables();
    this.addListeners();
  }

  disconnectedCallback() {
    this.removeListeners();
  }

  setVariables() {
    this.card = this.closest('product-card');
    this.action = this.dataset.action;
  }

  addListeners() {
    this.addEventListener('click', this.#onClick);
    document.addEventListener(ThemeEvents.variantSelected, this.#onVariantSelected);
  }

  removeListeners() {
    this.removeEventListener('click', this.#onClick);
    document.removeEventListener(ThemeEvents.variantSelected, this.#onVariantSelected);
  }

  #onClick = (e) => {
    const swatch = e.target.closest('.swatch');

    if (!swatch) return;
    
    e.preventDefault();
    e.stopPropagation();

    if (this.action === 'redirect') {
      this.redirect(swatch);
    } else {
      this.updateCard(swatch);
    }    
  };

  #onVariantSelected = (e) => {
    const target = e.target;
    const value = e.detail.resource.value.toLowerCase().replaceAll(' ', '-');
    const swatches = this.querySelectorAll('.swatch');

    if (!target.closest('[data-sync-product-cards-with-variant-picker]')) return;

    swatches.forEach(swatch => {
      let swatchValue = swatch.dataset.value.toLowerCase().replaceAll(' ', '-');
      if (swatchValue === value) {
        this.updateCard(swatch);
      }
    });
  }

  redirect(swatch) {
    window.location.href = swatch.dataset.href;
  }

  updateCard(swatch) {
    const variantId = swatch.dataset.variantId;
    const variantImage = swatch.dataset.variantImage;
    const preOrderdData = {
      active: swatch.dataset.preorderActive,
      cart_text: swatch.dataset.preorderCartText,
      cart_label: swatch.dataset.preorderCartLabel,
      precision: swatch.dataset.preorderPrecision,
    };

    this.updateSwatch(swatch);
    this.updateVariantId(variantId, preOrderdData);
    this.updateMedia(variantImage);
}

  updateSwatch(swatch) {
    swatch.closest('.swatches')?.querySelectorAll('.swatch').forEach(swatch => {
      swatch.removeAttribute('aria-checked');
    });
    swatch.setAttribute('aria-checked', 'true');
  }

  updateVariantId(variantId, preOrderdData) {
    const quickAdd = this.card?.querySelector('quick-add-component');
    const addToCartButton = quickAdd?.querySelector('[data-ref="add-to-cart-button"]');
    const preorderInfo = quickAdd?.querySelector('[data-ref="quick-add-preorder-info"]');

    if (!addToCartButton) return;

    let preorderActive = preOrderdData.active;
    const preorderPrecision = preOrderdData.precision;
    const preorderCartText = preOrderdData.cart_text;
    const preorderCartLabel = preOrderdData.cart_label;
    const preorderAddToCartText = addToCartButton.dataset.preorderAddToCartText;
    const addToCartTextContent = addToCartButton.querySelector('.button__content .full-add-to-cart-text');
    const addToCartTextSmallContent = addToCartButton.querySelector('.button__content .small-add-to-cart-text');
    const addToCartText = addToCartButton.dataset.addToCartText;
    const addText = addToCartButton.dataset.addText;
    
    if (preorderActive === 'true' && preorderPrecision) {
      preorderInfo.querySelector('.quick-add-preorder-info__text').textContent = preorderPrecision;
      addToCartTextContent.textContent = preorderAddToCartText;
      addToCartTextSmallContent.textContent = preorderAddToCartText;
      addToCartButton.dataset.preorderCartText = preorderCartText;
      addToCartButton.dataset.preorderCartLabel = preorderCartLabel;
      addToCartButton.dataset.preorderActive = preorderActive;
      preorderInfo.classList.remove('hidden');

    } else {
      preorderInfo.classList.add('hidden');
      addToCartTextContent.textContent = addToCartText;
      addToCartTextSmallContent.textContent = addText;
      addToCartButton.dataset.preorderActive = 'false';
    }

    addToCartButton.dataset.variantId = variantId;
  }

  updateMedia(variantImage) {
    const mediaGallery = this.card?.querySelector('product-card-media-gallery');
    const media = mediaGallery?.querySelector('.product-media');
    const image = media?.querySelector('img');

    if (!image || !variantImage) return;
    
    const currentImageUrl = image.src.split('&width=')[0].replace('https:', '');
    const newImageUrl = variantImage.split('&width=')[0].replace('https:', '');

    const newImageSrc = image.src.replaceAll(currentImageUrl, newImageUrl);
    const newImageSrcset = image.srcset.replaceAll(currentImageUrl, newImageUrl);

    image.setAttribute('src', newImageSrc);
    image.setAttribute('srcset', newImageSrcset);
  }
}

if (!customElements.get('product-card-swatches')) {
  customElements.define('product-card-swatches', ProductCardSwatches);
}
